<template>
  <div id="collection-list">
      <div v-show="hide_details || false" class="mr-auto float-right">
        <span
          class="btn btn-danger ml-2"
          @click="hide_details()"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      
      <div class="mr-auto float-left mb-2" v-if="search_bar">
        <div id="ctn-search-bar">
          <div class="d-flex flex-row justify-content-between">
            <div fluid class="d-flex flex-row"></div>
            <div fluid class="d-flex flex-row" id="search-bar">
              <b-input-group>
                <b-form-datepicker 
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="en"
                  today-button
                  reset-button
                  close-button
                  placeholder="Start date" v-model="date_start" required />
                <b-form-datepicker 
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  locale="en"
                  today-button
                  reset-button
                  close-button
                  placeholder="End date" v-model="date_end" required />
                <b-form-input placeholder="Bill of lading / Container" v-model="reference" required />
                <b-input-group-append>
                  <b-button variant="success" @click.prevent="searchUnits(3)">SEARCH</b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </div>
        </div>
      </div>

      <div class="mr-auto float-left" v-else>
        <b-form-group>
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="text-sm border-1">
        <b-table
          id="table-unit-list"
          class="table-grid"
          striped
          hover
          outlined
          show-empty
          table-variant="light"
          :empty-text="get_empty_text"
          empty-filtered-text="There are no records matching your request"
          :items="getCollectionList"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(amount)="data">
            <span>{{ data.value | numFormat(currency_format) }}</span>
          </template>

          <template slot="bottom-row" v-if="!filter && getTotalRows>1">
            <td v-show="showCarrierColumn"></td>
            <td v-show="showConsigneeColumn"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td >Total : </td>
            <td class="text-right">{{ getTotalCollected | numFormat(currency_format) }}</td>
            <td></td>
          </template>
        </b-table>
        <b-pagination
          v-show="getTotalRows > perPage"
          v-model="currentPage"
          :total-rows="getTotalRows"
          :per-page="perPage"
          aria-controls="my-table"
          align="fill"
          size="sm"
        />
    </div>
  </div>
</template>

<script>
export default {
  name: "CollectionList",
  components: {},
  props: {
    search_type: String,    
    numberUnitPerPage: Number,
    hide_details: Function,
    search_bar: Boolean,
  },
  data() {
    return {
      first_load: true,
      date_start: "",
      date_end: "",
      reference: "",
      currency_format: "$ 0,0.00",
      currentPage: 1,
      totalRows: 0,
      TotalUnpaid: 0,
      fields: [
        { key: "carrier_code", label: "Carrier", sortable: true },
        { key: "consignee_name", label: "Consignee", sortable: true },
        { key: "bol_reference", label: "Bill of lading", sortable: true },
        { key: "ctn_reference", label: "Container", sortable: true },
        { key: "document_type", label: "Transaction", sortable: true },
        { key: "document_no", label: "Reference", sortable: true },
        {
          key: "transaction_date",
          label: "Transaction",
          sortable: true,
          formatter: (value) => {
            return value == "0000-00-00" ? "" : value;
          },
        },
        { key: "phase", label: "Charge", sortable: true },
        {
          key: "amount",
          label: "Collected",
          sortable: true,
          class: "text-right",
        },
        { key: "remitted_date", label: "Remittance", sortable: true,
          formatter: (value) => {
            return value == "0000-00-00" ? "" : value;
          },
         },
        
      ],
      filter: null,
      filterOn: ["carrier_code", "consignee", "bol_reference", "ctn_reference"],
      filteredItems: [],
    };
  },
  computed: {
    showCarrierColumn(){
      return this.$store.state.current_profile.type == 4 ? false : true;
    },
    showConsigneeColumn(){
      return this.$store.state.current_profile.type == 6 ? false : true;
    },
    get_empty_text() {
      return this.first_load ? "Please type a bill of lading or container reference then click on the 'SEARCH' button" : "There are no records matching your request";
    },
    getTotalCollected() {
      try {
        return this.filter
          ? this.filteredItems.reduce((sum, cv) => sum + cv.amount, 0)
          : this.getCollectionList.reduce((sum, cv) => sum + cv.amount, 0);
      } catch {
        return 0;
      }
    },
    getTotalRows() {
      try {
        return this.filter ? this.totalRows : this.getCollectionList.length;
      } catch {
        return 0;
      }
    },
    perPage() {
      return this.numberUnitPerPage <= 0
        ? this.getTotalRows()
        : this.numberUnitPerPage;
    },
    getCollectionList: function () {
      return this.$store.getters.collections_list;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.TotalUnpaid = filteredItems.reduce(
        (sum, cv) => sum + cv.unpaid_amount,
        0
      );
      this.currentPage = 1;
    },
    searchUnits() {
      let date_start = this.date_start ? this.date_start : "";
      let date_end = this.date_end ? this.date_end : "";
      let reference = this.reference ? this.reference.replace(/\s+/g, "") : "";
      let action = "get_collections";
      //var client_id = this.$store.state.current_profile.id;
      
      if (date_start=="" && date_end!="") {
        alert("Please type the start date");
        return;
      }
      if (date_end=="" && date_start!="") {
        alert("Please type the end date");
        return;
      }
      if ((date_start=="" || date_end=="") && reference == "") {
        alert("Please specify a criteria to search");
        return;
      }

      let payload = { reference, date_start, date_end };

      this.$store.dispatch(action, payload);
      this.$emit("submit", payload);
    },
  },
};
</script>
